import { combineReducers } from "redux";
import columnOneReducer from "./columnOneReducer";

export default combineReducers({
  columnOne: columnOneReducer
});
